package br.com.htms.inspeccaocampo.platform

data class PhotoStampData(
    val tstResponsavel: String,
    val pergunta: String,
    val resposta: String,
    val responsavelFrente: String,
    val localTexto: String,
    val dataHoraMs: Long,
    val latitude: Double?,
    val longitude: Double?,
    val numeroInspecao: Long? = null
)

data class ImageSize(val width: Int, val height: Int)

expect object PlatformImage {
    /**
     * Aplica carimbo de texto sobre a foto (JPEG) no próprio arquivo.
     * @return bytes JPEG carimbados, ou null se falhou.
     *         Na Web o PDF depende desses bytes (Base64 no form) — não só do path.
     */
    suspend fun applyStamp(path: String, dados: PhotoStampData): ByteArray?

    fun imageSize(bytes: ByteArray): ImageSize?

    /** Converte PNG/JPEG bytes para JPEG (para PDF/Excel). */
    suspend fun toJpegBytes(bytes: ByteArray, quality: Float = 0.9f): ByteArray?

    /** Solicita permissões de câmera/localização (no-op se já concedidas). */
    suspend fun requestPermissions(): Boolean
}
